import React from "react";
import { Grid, TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { LocalLibrary, MenuBook, Badge } from "@mui/icons-material";
import { COURSE_TYPES } from "../../../services/formConfig";

const InstitutionForm = () => {
  const { values, handleChange, touched, errors, setFieldValue } = useFormikContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Field
          as={TextField}
          name="institutionName"
          label="Instituição"
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocalLibrary />
              </InputAdornment>
            ),
          }}
          error={touched.institutionName && Boolean(errors.institutionName)}
          helperText={touched.institutionName && errors.institutionName}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          as={TextField}
          name="customCourse"
          label="Curso"
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MenuBook />
              </InputAdornment>
            ),
          }}
          error={touched.customCourse && Boolean(errors.customCourse)}
          helperText={touched.customCourse && errors.customCourse}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Field
          as={TextField}
          name="registrationNumber"
          label="Número de Registro"
          fullWidth
          margin="normal"
          disabled={values.registrationNotProvided}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Badge />
              </InputAdornment>
            ),
          }}
          error={touched.registrationNumber && Boolean(errors.registrationNumber)}
          helperText={touched.registrationNumber && errors.registrationNumber}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="registration-not-label">Não informar</InputLabel>
          <Select
            labelId="registration-not-label"
            name="registrationNotProvided"
            value={values.registrationNotProvided ? "true" : "false"}
            label="Não informar"
            onChange={(e) => setFieldValue("registrationNotProvided", e.target.value === "true")}
          >
            <MenuItem value="false">Informar</MenuItem>
            <MenuItem value="true">Não informar</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={12}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="courseType-label">Tipo de Curso</InputLabel>
          <Select
            labelId="courseType-label"
            name="courseType"
            value={values.courseType}
            label="Tipo de Curso"
            onChange={handleChange}
          >
            {COURSE_TYPES.map((course) => (
              <MenuItem key={course.value} value={course.value}>
                {course.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default InstitutionForm;